import React, { useState, useContext } from "react";
import { HiChevronDown, HiUser } from "react-icons/hi";
import SessionStorageService from "../../../../services/StorageService";
import { ButtonGroup, Menu, MenuItem, Avatar, Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router";
import AuthAPI from "../../../../apis/AuthAPI";
import { toast } from "react-toastify";
import { ConstantAPISContext } from "../../../../context/ConstantAPISContext";
import { ThemeContext } from "../../../../context/themeProviderContext";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ChangePassword from "../../../../pages/OB/SifreYenile"
 
const ProfileComponent = (props:any) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const navigate = useNavigate();
  let user = SessionStorageService.getUserInfo();
  

  const { reloadTheme }: any = useContext(ThemeContext)
 
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const [passwordDialogOpen, setPasswordDialogOpen] = useState(false);

  // şifre yenile popup
  const handlePasswordChangeClick = () => {
    setAnchorEl(null);
    setPasswordDialogOpen(true);
  };

  const handlePasswordDialogClose = () => {
    setPasswordDialogOpen(false);
  };
 
  
  const {setKullaniciVarmi}=useContext(ConstantAPISContext)
  const cikisYap = () => {
    AuthAPI.signOut()
      .then((value) => {
        if (value) {
          setKullaniciVarmi(false);
          navigate("/");
          reloadTheme();
        } else {
          toast.error("Çıkış yapılamadı");
        }
      })
      .catch((error) => {
        console.error("Çıkış sırasında hata:", error);
        toast.error("Çıkış yapılırken bir hata oluştu");
      });
  };
  
 
  return user ? (
<Box
      className="d-flex align-items-center"
      sx={{ padding: 1, backgroundColor: 'transparent', cursor: 'pointer' }}
>
<Avatar
        onClick={handleClick}
        sx={{
          bgcolor: 'primary.main',
          width: 40,
          height: 40,
          fontWeight: 600,
          fontSize: '0.875rem',
          letterSpacing: '0.05em',
          textTransform: 'uppercase',
          color: 'common.white',
          transition: 'box-shadow 0.2s ease',
          '&:hover': {
            boxShadow: '0 0 0 4px rgba(0, 0, 0, 0.2)'
          }
        }}
>
{user != null ?`${user.adi != null?user.adi.charAt(0):""}${user.soyadi != null ? user.soyadi.charAt(0):""}`:""}</Avatar>
<Menu
        id="profile-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
>
<MenuItem onClick={() => { setAnchorEl(null); navigate("/sicil-bilgileri"); }}>Sicil Bilgileri</MenuItem>
{user.sicilGiris ? null:<MenuItem onClick={() => { setAnchorEl(null); navigate("/profil-guncelle"); }}>Profil Bilgileri</MenuItem>}
<MenuItem onClick={handlePasswordChangeClick}>Şifremi Değiştir</MenuItem>
<MenuItem onClick={() => { setAnchorEl(null); cikisYap(); }}>Çıkış</MenuItem>
</Menu>
<Dialog
  open={passwordDialogOpen}
  onClose={handlePasswordDialogClose}
  maxWidth="sm"
  fullWidth
  PaperProps={{
    sx: {
      borderRadius: 2,
      position: 'relative'
    }
  }}
>
  <IconButton
    aria-label="close"
    onClick={handlePasswordDialogClose}
    sx={{
      position: 'absolute',
      right: 8,
      top: 8,
      color: (theme) => theme.palette.grey[500],
      zIndex: 1
    }}
  >
    <CloseIcon />
  </IconButton>
  
  <DialogContent sx={{ p: 0 }}>
    <ChangePassword onSuccess={handlePasswordDialogClose} />
  </DialogContent>
</Dialog>
</Box>
  ) : (
<ButtonGroup className="py-2 gap-2">
<Button variant="contained" onClick={() => navigate("/login")}>
        Giriş Yap
</Button>
<Button onClick={() => navigate("/uyelik-kayit")} variant="outlined">
        Kayıt Ol
</Button>
</ButtonGroup>
  );
};
 
export default ProfileComponent;